module.exports = __webpack_public_path__ + "static/media/Poliwrath_gaussian2.68eaed99.png";